export default {
  ui: {
    colors: {
      primary: "violet",
      success: "success",
      error: "error",
      warning: "warning",
      info: "info",
      secondary: "secondary",
      tertiary: "tertiary",
      quaternary: "quaternary",
      neutral: "stone",
      amber: "amber",
      emerald: "emerald",
      purple: "purple",
      red: "red",
      orange: "orange",
      yellow: "yellow",
      lime: "lime",
      green: "green",
      teal: "teal",
      cyan: "cyan",
      sky: "sky",
      blue: "blue",
      indigo: "indigo",
      violet: "violet",
      fuchsia: "fuchsia",
      pink: "pink",
      rose: "rose",
      gray: "gray",
      slate: "slate",
      zinc: "zinc",
      white: "white",
      black: "black",
      nude: "nude",

      group_red: "group_red",
      group_orange: "group_orange",
      group_orangedark: "group_orangedark",
      group_amber: "group_amber",
      group_yellow: "group_yellow",
      group_lime: "group_lime",
      group_green: "group_green",
      group_emerald: "group_emerald",
      group_teal: "group_teal",
      group_cyan: "group_cyan",
      group_sky: "group_sky",
      group_blue: "group_blue",
      group_indigo: "group_indigo",
      group_violet: "group_violet",
      group_purple: "group_purple",
      group_fuchsia: "group_fuchsia",
      group_pink: "group_pink",
      group_rose: "group_rose",
      group_gray: "group_gray",
      group_stone: "group_stone",
      group_slate: "group_slate",
      group_zinc: "group_zinc",
      group_neutral: "group_neutral",
      group_white: "group_white",
      group_black: "group_black",
    },
    input: {
      defaultVariants: {
        variant: "soft",
      },
    },
    card: {
      slots: {
        root: "rounded-lg overflow-hidden bg-elevated",
        header: "p-4 sm:px-6",
        title: "text-highlighted font-semibold",
        description: "mt-1 text-muted text-sm",
        body: "p-4 sm:p-6",
        footer: "p-4 sm:px-6",
      },
      variants: {
        variant: {
          solid: {
            root: "bg-inverted text-inverted",
            title: "text-inverted",
            description: "text-dimmed",
          },
          outline: {
            root: "bg-default ring ring-default divide-y divide-default",
          },
          soft: {
            root: "bg-elevated divide-y divide-default",
          },
          subtle: {
            root: "bg-elevated ring ring-default divide-y divide-default",
          },
        },
      },
      defaultVariants: {
        variant: "soft",
      },
    },
    pricingTable: {
      variants: {
        section: {
          true: {
            tr: "*:pt-0",
          },
        },
      },
    },
    dashboardPanel: {
      slots: {
        root: "relative flex flex-col min-w-0 min-h-[calc(100vh-1.5rem)] max-h-[calc(100vh-1.5rem)] lg:not-last:border-r lg:not-last:border-default shrink-0 my-3 mr-3 bg-white dark:bg-[#181A1B] rounded-lg h-[calc(100vh-1.5rem)] overflow-hidden ring-1 ring-neutral-200 dark:ring-neutral-800",
        body: "flex flex-col gap-4 sm:gap-6 flex-1 overflow-y-auto p-4 sm:p-6 ",
        handle: "",
      },
    },
    icons: {
      light: "i-heroicons-sun",
      dark: "i-heroicons-moon",
    },
    modal: {
      slots: {
        overlay: "fixed inset-0 bg-neutral-800/80",
      },
    },
    editor: {
      slots: {
        base: [
          // Tables
          // "[&_table]:w-full [&_table]:border-separate [&_table]:border-spacing-0 [&_table]:rounded-md",
          // "[&_th]:py-3 [&_th]:px-4 [&_th]:font-semibold [&_th]:text-sm [&_th]:text-left [&_th]:bg-muted/50 [&_th]:border-t [&_th]:border-b [&_th]:border-e [&_th]:first:border-s [&_th]:border-muted",
          // "[&_th_p]:my-0 [&_th_p]:leading-5",
          // "[&_td]:py-3 [&_td]:px-4 [&_td]:text-sm [&_td]:text-left [&_td]:border-b [&_td]:border-e [&_td]:first:border-s [&_td]:border-muted",
          // "[&_td_p]:my-0 [&_td_p]:leading-5 [&_td_code]:text-xs/5 [&_td_ul]:my-0 [&_td_ol]:my-0 [&_td_ul]:ps-4.5 [&_td_ol]:ps-4.5 [&_td_li]:leading-6 [&_td_li]:my-0.5",
          // "[&_tr:first-child_th:first-child]:rounded-tl-md [&_tr:first-child_th:last-child]:rounded-tr-md [&_tr:last-child_td:first-child]:rounded-bl-md [&_tr:last-child_td:last-child]:rounded-br-md",
          // "[&_.selectedCell]:bg-primary/10 [&_.selectedCell]:ring-2 [&_.selectedCell]:ring-primary [&_.selectedCell]:ring-inset",
          // // Task lists
          // "[&_ul[data-type=taskList]]:list-none [&_ul[data-type=taskList]]:ps-1",
          // "[&_ul[data-type=taskList]_li]:flex [&_ul[data-type=taskList]_li]:items-center [&_ul[data-type=taskList]_li]:ps-0",
          // "[&_ul[data-type=taskList]_li_label]:inline-flex [&_ul[data-type=taskList]_li_label]:pr-2.5",
          // "[&_ul[data-type=taskList]_li_label_input]:appearance-none [&_ul[data-type=taskList]_li_label_input]:size-4 [&_ul[data-type=taskList]_li_label_input]:rounded-xs [&_ul[data-type=taskList]_li_label_input]:ring [&_ul[data-type=taskList]_li_label_input]:ring-inset [&_ul[data-type=taskList]_li_label_input]:ring-accented [&_ul[data-type=taskList]_li_label_input]:bg-center",
          // "[&_ul[data-type=taskList]_li_label_input:checked]:bg-emerald-500 [&_ul[data-type=taskList]_li_label_input:checked]:ring-emerald-500 [&_ul[data-type=taskList]_li_label_input:checked]:bg-[url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTIwIDZMOSAxN2wtNS01Ii8+PC9zdmc+)] dark:[&_ul[data-type=taskList]_li_label_input:checked]:bg-[url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTIwIDZMOSAxN2wtNS01Ii8+PC9zdmc+)]",
        ],
      },
      variants: {
        placeholderMode: {
          firstLine: {
            base: "[&_:is(p,h1,h2,h3,h4,h5,h6).is-editor-empty:first-child]:before:content-[attr(data-placeholder)] [&_:is(p,h1,h2,h3,h4,h5,h6).is-editor-empty:first-child]:before:text-dimmed [&_:is(p,h1,h2,h3,h4,h5,h6).is-editor-empty:first-child]:before:float-start [&_:is(p,h1,h2,h3,h4,h5,h6).is-editor-empty:first-child]:before:h-0 [&_:is(p,h1,h2,h3,h4,h5,h6).is-editor-empty:first-child]:before:pointer-events-none",
          },
          everyLine: {
            base: "[&_:is(p,h1,h2,h3,h4,h5,h6).is-empty]:before:content-[attr(data-placeholder)] [&_:is(p,h1,h2,h3,h4,h5,h6).is-empty]:before:text-dimmed [&_:is(p,h1,h2,h3,h4,h5,h6).is-empty]:before:float-start [&_:is(p,h1,h2,h3,h4,h5,h6).is-empty]:before:h-0 [&_:is(p,h1,h2,h3,h4,h5,h6).is-empty]:before:pointer-events-none",
          },
        },
      },
      defaultVariants: {
        placeholderMode: "everyLine",
      },
    },
  },
};
